import { useEffect } from 'react'

import { Avatar, Card, Center, Paper } from '@mantine/core'
import { Title } from 'react-admin'

import styles from './Login.module.scss'

type LoginLayoutProps = {
  title: string
  children: JSX.Element
}

export const LoginLayout = ({ title, children }: LoginLayoutProps) => {
  useEffect(() => {
    document.title = `${title} | Logicomix Studio`
  }, [title])

  return (
    <Paper className={styles.root} w="100vw">
      <Title>{title}</Title>
      <Card className={styles.card} p="xs">
        <Center m="md">
          <Avatar src="/lx-logo.png" />
        </Center>
        {children}
      </Card>
    </Paper>
  )
}
